const DASHBOARD_MIN_VERSION_HEADER = 'dashboard-min-ver';

let currentVersion = null;
let isNewVersionExist = false;

// This section needed for fast testing
window.addEventListener('reduce-dashboard-min-version', () => {
  if (currentVersion) {
    currentVersion--;
    console.log('Dashboard version was reduced. New version: ', currentVersion);
  }
});

// The header holds a fixed-width integer (YYMMDDNNN). Returns null when it is missing, blank or not a number.
const parseVersion = (value) => {
  if (typeof value !== 'string' && typeof value !== 'number') {
    return null;
  }
  const text = String(value).trim();
  if (text === '') {
    return null;
  }
  const version = Number(text);
  return isFinite(version) ? version : null;
};

export const handleVersion = (res) => {
  const headers = res && res.headers;
  const newVersion = parseVersion(headers ? headers[DASHBOARD_MIN_VERSION_HEADER] : undefined);
  if (newVersion === null) {
    return;
  }
  if (currentVersion === null) {
    currentVersion = newVersion;
  } else if (newVersion > currentVersion) {
    isNewVersionExist = true;
  }
};

export const isVersionObsolete = () => {
  return isNewVersionExist;
};

export const updatePage = () => {
  console.log('Clearing cache and hard reloading...');
  if (window.caches) {
    // Service worker cache should be cleared with window.caches.delete()
    window.caches.keys().then((names) => {
      names.forEach((name) => window.caches.delete(name));
    });
  }
  localStorage.clear();
  window.location.reload(true);
};

export const checkVersion = () => {
  if (isVersionObsolete()) {
    updatePage();
  }
};
